<template>
  <a-card>
    <a-table v-if="data.length !== 0" :pagination="false" :columns="columns" size="middle" :data-source="data" row-key="id" :default-expand-all-rows="true">
      <span slot="workflow_title" slot-scope="text, record">
        <span v-if="record.id === workflowId"><a-icon type="star" theme="filled" style="color: #ffd700" /> {{ record.title }} </span>
        <a v-else class="custom-link" @click="onDetail(record)"> {{ record.title }} </a>
      </span>
      <span slot="creator" slot-scope="text, record">
        <user-profiles :value="[record.creator.id]" avatar />
      </span>
      <span slot="avatar" slot-scope="text, record">
        <a-avatar shape="square" :size="48" icon="user" :src="record.creator.avatar_url" class="table-image" />
      </span>
      <span slot="workflow_type" slot-scope="text, record">{{ record.workflow_type.label }}</span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="workflowStatus[record.status.value].status" :text="workflowStatus[record.status.value].label" />
      </span>
      <span slot="progress" slot-scope="text, record">
        <a-progress stroke-linecap="round" :percent="record.progress" :status="record.status.value === 3 ? 'exception' : null" :stroke-width="10" />
      </span>
    </a-table>
  </a-card>
</template>
<script>
import { workflowStatus } from '@/utils/dictionary';
const columns = [
  {
    title: '流程标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    scopedSlots: { customRender: 'workflow_title' }
  },
  {
    title: '创建人',
    width: '11%',
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '流程模板',
    dataIndex: 'template_name',
    key: 'template_name',
    width: '10%',
    align: 'center'
  },
  {
    title: '流程类型',
    scopedSlots: { customRender: 'workflow_type' },
    width: '8%',
    align: 'center'
  },

  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: '14%',
    align: 'center'
  },

  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    width: '14%',
    align: 'center'
  },
  {
    title: '状态',
    align: 'center',
    width: '6%',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '当前进度',
    align: 'center',
    width: '14%',
    scopedSlots: { customRender: 'progress' }
  }
];
export default {
  name: 'WorkflowRelationFrom',
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      workflowStatus,
      workflowId: parseInt(this.$route.query.workflowId),
      expandedRowKeys: []
    };
  },
  methods: {
    // 查看工作流详情
    onDetail(record) {
      const route = this.$router.resolve({
        name: 'page:project:workflow:detail',
        params: { project_id: record.project_id },
        query: { workflowId: record.id }
      });
      window.open(route.href, '_blank');
    }
  }
};
</script>
<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
/deep/.ant-card-body {
  padding: 16px;
}
</style>
